import React, { useContext, useEffect, useState } from "react";
import "./WorkshopMaterials.css";
import { AppContext } from "../../../AppContext";
import beOneBlueIcon from "../../../assets/beOneBlueIcon";
import closeSvg from "../../../assets/closeSvg";
import FiveQuestions from "./FiveQuestions";
import { FiveQuestionsContext } from "./FiveQuestionsContext";
import { WhatsUpWhatsNextContext } from "./WhatsUpWhatsNextContext";
import WhatsUpWhatsNext from "./WhatsUpWhatsNext";
import TransferToMove from "../Account/TransferToMove/TransferToMoveModal";
import { TransferToMoveContext } from "../Account/TransferToMove/TransferToMoveContext";
import { logActivity } from "../../utils";
import sandovalTeamIcon from "../../../assets/sandovalTeamIcon";

const WorkshopMaterials = () => {
  const {
    workshopMaterials,
    setWorkshopMaterials,
    userCompany,
    userEmail,
    makeKey,
    userType,
  } = useContext(AppContext);

  const [workshopLinks, setWorkshopLinks] = useState("1");
  const [materialIcons, setMaterialIcons] = useState("1");
  const [sectionSelected, setSectionSelected] = useState("The Play");
  const [beOneCertification, setBeOneCertification] = useState("");
  const [newAgentSprints, setNewAgentSprints] = useState("");
  const [newLead, setNewLead] = useState("The Play");
  const [newLeadChecklist, setNewLeadChecklist] = useState("");
  const [showings, setShowings] = useState("");
  const [buyersPreso, setBuyersPreso] = useState("");
  const [buyingProcess, setBuyingProcess] = useState("");

  const [fiveQuestionsVisible, setFiveQuestionsVisible] = useState(false);
  const [wUWNVisible, setWUWNVisible] = useState(false);
  const [transferToMoveVisible, setTransferToMoveVisible] = useState(false);

  useEffect(() => {
    setSectionSelected("The Play");
    if (userCompany == "Be1 Team" || userCompany == "Move Mortgage") {
      const beOneLinksUrl = `/.netlify/functions/getBeOneLinks`;
      fetch(beOneLinksUrl, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((body) => {
          setBeOneCertification(
            body.workshopLinks.find((e) => {
              return e[0] == "Be1 Certification";
            })[1]
          );
          setNewLead(
            body.workshopLinks.find((e) => {
              return e[0] == "New Lead Script";
            })[1]
          );
          setNewLeadChecklist(
            body.workshopLinks.find((e) => {
              return e[0] == "New Lead Checklist";
            })[1]
          );
          setNewAgentSprints(
            body.workshopLinks.find((e) => {
              return e[0] == "New Agent Sprints";
            })[1]
          );
          setBuyingProcess(
            body.workshopLinks.find((e) => {
              return e[0] == "The Buying Process";
            })[1]
          );
          setShowings(
            body.workshopLinks.find((e) => {
              return e[0] == "Showings Checklist";
            })[1]
          );
          setBuyersPreso(
            body.workshopLinks.find((e) => {
              return e[0] == "Why Me Script";
            })[1]
          );
          setWorkshopLinks(
            setMaterialIcons(
              body.workshopLinks
                .filter((e) => e[2] == "Be1 Team")
                .map((e, index) => {
                  return (
                    <a
                      className="workshopMaterialIcon"
                      tabIndex={-1}
                      key={index}
                      href={e[1]}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span className="workshopMaterialText">{e[0]}</span>
                    </a>
                  );
                })
            )
          );
        });
    }
    if (userCompany == "Sandoval Team") {
      const beOneLinksUrl = `/.netlify/functions/getBeOneLinks`;
      fetch(beOneLinksUrl, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((body) => {
          setNewLead(
            body.workshopLinks.find((e) => {
              return e[0] == "Sandoval New Lead Script";
            })[1]
          );
          setWorkshopLinks(
            setMaterialIcons(
              body.workshopLinks
                .filter((e) => e[2] == "Sandoval Team")
                .map((e, index) => {
                  return (
                    <a
                      className="workshopMaterialIcon"
                      tabIndex={-1}
                      key={index}
                      href={e[1]}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span className="workshopMaterialText">{e[0]}</span>
                    </a>
                  );
                })
            )
          );
        });
    }
  }, [userCompany]);

  const steps = () => {
    if (userCompany == "Be1 Team" || userCompany == "Move Mortgage") {
      return (
        <>
          <div className="thePlaySection" id="thePlay">
            <div className="twentyFivePx"></div>
            <div className="twentyFivePx"></div>
            <div className="tenPx"></div>
            <b className="title">The Play</b>
            <div className="tenPx"></div>
            <div className="thePlayStep">
              <div>
                <b>Be One Certification & Onboarding</b>
                <hr className="full-bar"></hr>
                Check out the Be One Certification rubric below! The "Why me?
                Buyers Preso Script" in Step 3 includes more details and
                suggested verbiage. If you need a visual, check out the Example
                Video below.
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={beOneCertification}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    Be One Certification
                  </span>
                </a>
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href="https://drive.google.com/file/d/19nYsPORvFo96jHxJioNqqIYFYYcBMSwj/view?usp=sharing"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">Example Video ▶️</span>
                </a>
              </ul>
              <hr className="full-bar"></hr>
              Upon finishing onboarding, please complete the 30/60/90 day sprints in the link below.
              <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={newAgentSprints}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    New Agent Sprints
                  </span>
                </a>
            </div>
            <div className="twentyFivePx"></div>
            <div className="thePlayStep">
              <div>
                <b>🤗 Step 1 | Caring for a New Zillow Lead</b>
                <hr className="full-bar"></hr>
                Let’s start with the Zillow Lead Script!{" "}
                <i>Learn. Practice. Repeat.</i> The script should become habit.
                After taking a new lead, update Follow Up Boss with What’s Up?
                What’s Next?
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={newLeadChecklist}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    Zillow Lead Checklist
                  </span>
                </a>
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={newLead}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">
                    Zillow Lead Script
                  </span>
                </a>
                <div
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={() => {
                    setWUWNVisible(true);
                  }}
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">
                    What's up? What's next?
                  </span>
                </div>
              </ul>
            </div>
            <div className="twentyFivePx"></div>
            <div className="thePlayStep">
              <div>
                <b>🏠 Step 2 | Showing Homes</b>
                <hr className="full-bar"></hr>
                As you prepare for your showing, print out the showing checklist
                and complete it! This will set you apart from other agents and
                give you confidence by ensuring you are 100% prepared.
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={showings}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    Showings Checklist
                  </span>
                </a>
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={
                    "https://www.compass.com/marketing-center/editor/v2/e5fedc72-5b7c-4c00-af39-106312441666"
                  }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    Build your <br></br>Flyer Here
                  </span>
                </a>
              </ul>
            </div>
            <div className="twentyFivePx"></div>
            <div className="thePlayStep">
              <div>
                <b>🌟 Step 3 | Presenting yourself, as a Pro</b>
                <hr className="full-bar"></hr>
                During the home tour, you will ask the 4 Questions. The goal of
                your conversations will be to get thorough answers to each
                question. Being a good listener will make you present like a PRO
                and build trust. After listening, you will then present your
                "Why me?"
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <div
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={() => {
                    setFiveQuestionsVisible(true);
                  }}
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">4 Questions</span>
                </div>
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={buyersPreso}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">
                    Why me? Buyers Preso Script
                  </span>
                </a>
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={buyingProcess}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="workshopMaterialText">
                    The Buying Process Script
                  </span>
                </a>
              </ul>
            </div>
            <div className="twentyFivePx"></div>
            <div className="thePlayStep">
              <div>
                <b>✍️ Step 4 | Setting yourself up for success</b>
                <hr className="full-bar"></hr>
                After meeting with your client, add a note in Follow Up Boss
                with your client's answers to the 4 Questions. After that, add a
                task/appointment to identify what you are doing next to take
                care of the client. Completing this step, is essentially to
                making you stand out and taking excellent care of your clients.
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <div
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={() => {
                    setWUWNVisible(true);
                  }}
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">
                    What's up? What's next?
                  </span>
                </div>
              </ul>
            </div>
            <div className="twentyFivePx"></div>
            <div className="thePlayStep">
              <div>
                <b>🔁 Step 5 | Lender Transfer</b>
                <hr className="full-bar"></hr>
                <div className="indentTen">
                  <b>1️⃣ Identify Preferred Lender</b>
                  <br></br>
                  <ul>
                    <li>
                      <b>If tagged as "ZHL Interested":</b> Consider transfering
                      to Zillow Home Loans. If you prefer to use Move, you may
                      proceed with transferring to Move.
                    </li>
                    <li>
                      <b>All other:</b> Transfer to Move Mortgage.
                    </li>
                  </ul>
                  <b>2️⃣ Prepare your Client</b>
                  <br></br>
                  Avoid overcomplicating this step! When meeting with your
                  client, inform them that you will be setting them up with your
                  preferred lender to review financing options.<br></br>
                  <br></br>
                  <b>3️⃣ Notify Preferred Lender</b>
                  <br></br>
                  If assigning to Move's "First Available" loan officer, you may
                  skip or perform the <b>Call</b> and <b>Group Text</b> as you
                  see fit. Otherwise, please:
                  <ul>
                    <li>
                      <b>Call:</b> Call your Loan Officer and inform them about
                      your client.
                    </li>
                    <li>
                      <b>Group Text:</b> Send a three-way text introducing your
                      client to your Loan Officer.
                    </li>
                    <li>
                      <b>Transfer Button:</b> For transfer to ZHL, navigate to
                      Zillow Premier app to click the transfer to ZHL button.
                      For Move, click below:
                    </li>
                  </ul>
                </div>
              </div>
              <ul className="playSectionMaterialsList">
                <div
                  className="panel"
                  onClick={() => {
                    setTransferToMoveVisible(true);
                    logActivity({
                      apiKey: makeKey,
                      userEmail: userEmail,
                      userType: userType,
                      action: "Transfer to Move Button",
                      tab: "Account",
                      userCompany: userCompany,
                    });
                  }}
                >
                  Transfer to Move
                </div>
              </ul>
            </div>
          </div>
          <div className="allScriptsSection centered" id="allScripts">
            <div className="twentyFivePx"></div>
            <div className="twentyFivePx"></div>
            <div className="tenPx"></div>
            <b>All Scripts</b>
            <ul className="workshopMaterialsList" id="allScripts">
              {materialIcons}
            </ul>
            <div className="oneHundredPx"></div>
          </div>
        </>
      );
    } else if (
      userCompany == "Sandoval Team" ||
      userCompany == "Move Mortgage"
    ) {
      return (
        <>
          <div className="thePlaySection" id="thePlay">
            <div className="twentyFivePx"></div>
            <div className="twentyFivePx"></div>
            <div className="tenPx"></div>
            <b className="title">The Play</b>
            <div className="tenPx"></div>
            <div className="thePlayStep">
              <div>
                <b>🤗 Step 1 | Caring for a New Zillow Lead</b>
                <hr className="full-bar"></hr>
                Let’s start with the Zillow Lead Script!{" "}
                <i>Learn. Practice. Repeat.</i> The script should become habit.
              </div>
              <div className="tenPx"></div>
              <ul className="playSectionMaterialsList">
                <a
                  className="workshopMaterialIcon"
                  tabIndex={-1}
                  href={newLead}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="testOut">TEST OUT</div>
                  <span className="workshopMaterialText">New Lead Script</span>
                </a>
              </ul>
            </div>
          </div>
          <div className="allScriptsSection centered" id="allScripts">
            <div className="twentyFivePx"></div>
            <div className="twentyFivePx"></div>
            <div className="tenPx"></div>
            <b>All Scripts</b>
            <ul className="workshopMaterialsList" id="allScripts">
              {materialIcons}
            </ul>
            <div className="oneHundredPx"></div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <div className={workshopMaterials} tabIndex={-1}>
        <div className="stickyButtonsContainer">
          <div className="workshopButtonHolder">
            <button
              className={`button workshopButton ${
                sectionSelected == "The Play" ? "" : "notSelected"
              }`}
              onClick={() => {
                setSectionSelected("The Play");
                document.getElementById("thePlay").scrollIntoView();
              }}
            >
              The Play
            </button>
            <button
              className={`button workshopButton ${
                sectionSelected == "All Scripts" ? "" : "notSelected"
              }`}
              onClick={() => {
                document.getElementById("allScripts").scrollIntoView();
                setSectionSelected("All Scripts");
              }}
            >
              All Scripts
            </button>
          </div>
          <span
            className="close"
            onClick={() => {
              setWorkshopMaterials("fullScreen down");
            }}
          >
            {closeSvg}
          </span>
        </div>
        {steps()}
      </div>
      <FiveQuestionsContext.Provider
        value={{
          fiveQuestionsVisible,
          setFiveQuestionsVisible,
        }}
      >
        <FiveQuestions />
      </FiveQuestionsContext.Provider>
      <WhatsUpWhatsNextContext.Provider
        value={{
          wUWNVisible,
          setWUWNVisible,
        }}
      >
        <WhatsUpWhatsNext />
      </WhatsUpWhatsNextContext.Provider>
      <TransferToMoveContext.Provider
        value={{
          transferToMoveVisible,
          setTransferToMoveVisible,
          zindex: "five",
          successFunctions: [
            { function: setWorkshopMaterials, input: "fullScreen down" },
          ],
        }}
      >
        <TransferToMove formId={Math.random()} />
      </TransferToMoveContext.Provider>
    </>
  );
};

export default WorkshopMaterials;
